export interface TechpackState {
  techpack?: UITechpackModel
  loading: boolean
  errorMessage?: string
}

export const state: TechpackState = {
  techpack: undefined,
  loading: false
}

export type UITechpackAttachment = {
  _id: string
  link?: string
  metadata: {
    fileSize: string
    fileType: string
  }
  name: string
}

export type UITechpackModel = {
  _id: string
  company?: {
    _id: string
    name: string
  }
  link: string
  metadata: {
    fileSize: string
    fileType: string
  }
  product?: {
    _id: string
    code: string
    name: string
  }
  attachments?: Array<UITechpackAttachment>
}
